module.exports = __webpack_public_path__ + "static/media/5.0d2a3a4a.jpg";